import { jsx as e } from "react/jsx-runtime";
import { useMultiStyleConfig as r, Flex as s } from "@chakra-ui/react";
const a = ({ children: o, __TYPE: i, ...l }) => {
  const t = r("GlobalFooter");
  return /* @__PURE__ */ e(s, { sx: t.socialsContainer, role: "list", "aria-label": "SGI social media", ...l, children: o });
};
a.defaultProps = {
  __TYPE: "GlobalFooterSocials"
};
export {
  a as GlobalFooterSocials
};
